module.exports = __webpack_public_path__ + "media/images/workplace/SVG/Avatar-ab22d9e351b50fcdcedb1d8c948d37b3.svg";